export const NODE_NAME = 'heading';
export const HEADING_REGEX = new RegExp('^(#{1,' + 3 + '})\\s$');
